module.exports = __webpack_public_path__ + "static/media/FTS-BNB.f89b0199.svg";